import { render } from "./ArticlesCardList.vue?vue&type=template&id=73bb568e"
import script from "./ArticlesCardList.vue?vue&type=script&lang=ts"
export * from "./ArticlesCardList.vue?vue&type=script&lang=ts"
script.render = render

export default script